import { render, staticRenderFns } from "./balancePayRecord.vue?vue&type=template&id=47aa9b1c&scoped=true"
import script from "./balancePayRecord.vue?vue&type=script&lang=js"
export * from "./balancePayRecord.vue?vue&type=script&lang=js"
import style0 from "./balancePayRecord.vue?vue&type=style&index=0&id=47aa9b1c&prod&scoped=true&lang=scss"
import style1 from "./balancePayRecord.vue?vue&type=style&index=1&id=47aa9b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa9b1c",
  null
  
)

export default component.exports